export default "__VITE_ASSET__ClBDu5hi__"